// extracted by mini-css-extract-plugin
export default {"myClassroomsContainer":"MyClassrooms_myClassroomsContainer__O4QDe","myClassroomsBody":"MyClassrooms_myClassroomsBody__gzjuM","loading":"MyClassrooms_loading__bw4eV"};